// extracted by mini-css-extract-plugin
export default {"container":"CheckboxGroup_container__nP3ye","label":"CheckboxGroup_label__3rk4n","content":"CheckboxGroup_content__6j2vL"};